import { isWeb } from "tamagui";

import { borderSizeTokens } from "../../themes/token-space";

// Web-only pointer props. Avoids the native "tap twice" bug where focus
// captures the first press on touch devices.
export const webPointerProps = isWeb
  ? ({
      cursor: "pointer",
      focusable: true,
      tabIndex: 0,
      focusVisibleStyle: {
        outlineWidth: borderSizeTokens.border3,
        outlineColor: "$borderIntense",
        outlineStyle: "solid",
        outlineOffset: borderSizeTokens.border3,
      },
    } as const)
  : ({} as const);

// Web-only press-scale. Native uses Reanimated (see ./usePressScale).
export const webPressScale = isWeb ? ({ scale: 0.98 } as const) : ({} as const);

// `animateOnly` must be mutable — tamagui rejects `readonly string[]`.
export const webInteractiveTransition = isWeb
  ? { transition: "quick" as const, animateOnly: ["transform"] }
  : ({} as const);

// Shared disabled treatment — suppresses hover/press feedback; not-allowed on web.
// `borderColor` is re-emitted in hover/press to prevent the interactive variant's
// `$borderDefaultHover` from leaking through Tamagui's deep variant merge.
export const disabledInteractiveStyles = {
  backgroundColor: "$bgDisabledSubtle",
  ...(isWeb ? ({ cursor: "not-allowed", tabIndex: -1 } as const) : {}),
  hoverStyle: {
    backgroundColor: "$bgDisabledSubtle",
    borderColor: "$borderDefault",
  },
  pressStyle: {
    backgroundColor: "$bgDisabledSubtle",
    borderColor: "$borderDefault",
    scale: 1,
  },
} as const;
